export default {
  "hideOnDrag": "_hideOnDrag_8cy2w_1",
  "dropBefore": "_dropBefore_8cy2w_6",
  "dropAfter": "_dropAfter_8cy2w_7",
  "dropPop": "_dropPop_8cy2w_1",
  "dropVertical": "_dropVertical_8cy2w_19",
  "dropHorizontal": "_dropHorizontal_8cy2w_25"
};import "ni:sha-256;vRk2K7bGdxRV6Ouv-7qTHlq6iLEb_K3fdLJnOOtNpVE";